
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.5 11a.5.5 0 01-.353-.854L22.793 5.5 18.147.854a.5.5 0 01.707-.708l5 5A.5.5 0 0124 5.5a.5.5 0 01-.146.354l-5 5A.5.5 0 0118.5 11z"}}),_c('path',{attrs:{"d":"M20.5 24h-11a9.5 9.5 0 010-19h14a.5.5 0 010 1h-14a8.5 8.5 0 000 17h11a.5.5 0 010 1z"}})])
          )
        }
      }
    